import React from 'react';
import { motion } from 'framer-motion';
import homeImage from '../assets/images/home.jpg';
import './Home.css';

function Home() {
    return (
        <motion.div
            className="home"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <h1>Welcome to Unpager</h1>
            
            <p>Web development that delivers results</p>
            <p>Let's build your online presence today!</p>
        </motion.div>
    );
}

// <img src={homeImage} alt="Home" />

export default Home;
